import { Stack } from "@chakra-ui/react";

import COLOR from "../../../../constant/COLOR";
import IMAGES from "../../../../constant/IMAGES";
import useResponsive from "../../../../hooks/useResponsive";
import formatLuna from "../../../../utils/formatLuna";
import {
  ContainRow,
  GridZodiac,
  Text,
  Title,
  TitleZodiac,
  WrapperQr,
} from "../style";
const canchiImages = [
  IMAGES.z1,
  IMAGES.z2,
  IMAGES.z3,
  IMAGES.z4,
  IMAGES.z5,
  IMAGES.z6,
  IMAGES.z7,
  IMAGES.z8,
  IMAGES.z9,
  IMAGES.z10,
  IMAGES.z11,
  IMAGES.z12,
];
interface SectionProps {
  detailCalendar: any;
}
const Section2: React.FC<SectionProps> = ({ detailCalendar }) => {
  const { isMobile } = useResponsive();

  return (
    <Stack justifyContent="center" width="100%" gap="24px" mt="20px">
      <TitleZodiac>Giờ hoàng đạo</TitleZodiac>

      <Stack
        gap="24px"
        p="24px"
        borderRadius="24px"
        height="100%"
        justifyContent="space-between"
        bg="linear-gradient(180deg, #F4E0B0 0%, rgba(244, 224, 176, 0) 100%)"
      >
        <GridZodiac>
          {detailCalendar?.gioHoangDao.map((day: any, idx: any) => (
            <Stack key={idx} alignItems="center" justifyContent="center">
              <img
                src={canchiImages[day?.order - 1]}
                alt=""
                style={{ height: "auto", width: "80px" }}
              />
              <Title
                style={{
                  textTransform: "capitalize",
                  marginTop: "20px",
                  fontSize: isMobile ? "15px" : "31px",
                  color: COLOR.primary900,
                }}
              >{`${formatLuna[day?.name.toLowerCase()]}`}</Title>
              <Text
                style={{
                  color: COLOR.gray800,
                  fontSize: isMobile ? "13px" : "28px",
                }}
              >
                {day?.start}:00 - {day?.end}:00
              </Text>
            </Stack>
          ))}
        </GridZodiac>
        <Stack
          sx={{ background: COLOR.primary500, width: "100%", height: "1px" }}
        />
        <Stack width="100%" alignItems="start" gap="24px">
          <ContainRow
            style={{ justifyContent: "space-between", width: "100%" }}
          >
            <Text style={{ color: COLOR.gray800 }}>Giờ thọ tử:</Text>
            <Title
              style={{ textTransform: "capitalize", color: COLOR.primary900 }}
            >
              {`${formatLuna[detailCalendar?.gioThoTu?.name?.toLowerCase()] || "---"}`}{" "}
              &#40;
              {detailCalendar?.gioThoTu?.start || "00"} : 00 -{" "}
              {detailCalendar?.gioThoTu?.end || "00"} : 00&#41;
            </Title>
          </ContainRow>
          <ContainRow
            style={{ justifyContent: "space-between", width: "100%" }}
          >
            <Text style={{ color: COLOR.gray800 }}>Giờ sát chủ:</Text>
            <Title
              style={{ textTransform: "capitalize", color: COLOR.primary900 }}
            >
              {`${formatLuna[detailCalendar?.gioSatChu?.name?.toLowerCase()] || "---"}`}{" "}
              &#40;
              {detailCalendar?.gioSatChu?.start || "00"} : 00 -{" "}
              {detailCalendar?.gioSatChu?.end || "00"} : 00&#41;
            </Title>
          </ContainRow>
        </Stack>
        <WrapperQr>
          <ContainRow>
            <img style={{ width: "40px" }} src={IMAGES.phone} alt="" />
            <a href="tel:1900 989 919">
              <Text style={{ color: COLOR.accent500, fontWeight: 600 }}>
                1900 989 919
              </Text>
            </a>
          </ContainRow>
          <img style={{ width: "144px" }} src={IMAGES.qr} alt="" />
        </WrapperQr>
      </Stack>
    </Stack>
  );
};

export default Section2;
